import PropTypes from 'prop-types'
import { ORIENTATION } from '../constants/orientation'

/**
 * Checks if property is a string with the value 'horizonal' or 'vertical'
 */
export const orientationPropType = PropTypes.oneOf([ORIENTATION.HORIZONTAL, ORIENTATION.VERTICAL])
